<div class="tp-page tp-page--narrow welcome">
  <section class="tp-card welcome__card">
    <img class="welcome__logo" src="assets/images/TuPiscinero-logo.png" alt="Tu Piscinero" />
    <tp-page-header title="¡Bienvenido a Tu Piscinero!" subtitle="Elegí una sección del menú para empezar."></tp-page-header>
  </section>
</div>
